import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { InputGroupType } from './models/input-group-type.enum';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputGroupComponent implements OnInit {
  private _controlName?: string;
  @Input() set controlName(value: string) {
    this._controlName = value;
    if (!this.name) {
      this.name = value;
    }
  }

  get formControlName(): string {
    return this._controlName!;
  }

  @Input() name?: string;
  @Input() placeholder?: string;
  @Input() icon?: string;
  @Input() text?: string;
  @Input() inputGroupType? = InputGroupType.InputGroupAppend;

  public type: typeof InputGroupType = InputGroupType;

  constructor() {}

  ngOnInit(): void {}
}
